import { render, staticRenderFns } from "./NewsData.vue?vue&type=template&id=f21f7bd0&scoped=true&"
import script from "./NewsData.vue?vue&type=script&lang=js&"
export * from "./NewsData.vue?vue&type=script&lang=js&"
import style0 from "./NewsData.vue?vue&type=style&index=0&id=f21f7bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21f7bd0",
  null
  
)

export default component.exports